/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2022-05-25 10:04:47
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-05-27 10:02:20
 */
import MeshManage from '../../meshManage';
import { AISLE_WIDTH, FRAMEDEPTH, FRAME_HEIGHT, HIGHTLOW_SINKCABINET_HEIGHT, SKIRTINGBOARDCONFIG, TOPPANELCONFIG, } from '../../utils/kitchenConfig';
import { getIsHighSinkCabinet, getDividingPosition } from '../../utils/templatejsonUtils';
/**
 * l1的台面数组
 * @param renderHThis
 * @param sinkLocation 水槽所在边
 * @param stoveLocation 燃气灶所在边
 */
export function getLengthXTopPanelInfo(renderHThis, lengthXLength, sinkLocation, stovePositionInfo) {
    var _a;
    // 判断水槽和灶台是否都在l1，如果只有一个在l1的话那边l1，l2不做台面的切割，如果水槽和燃气灶都在l1的话要做高低柜的切割
    // 先判断是不是高低柜 如果是高低柜那么再去判断位置信息
    // 二字型的水槽永远是在右边的  所以创建台面的时候高台面就是在右边的
    if (getIsHighSinkCabinet(renderHThis.templateJson)) {
        const { l1Frame: { frameInfo, }, } = getDividingPosition(renderHThis.templateJson);
        if (frameInfo) {
            const highCabinetId = (_a = frameInfo === null || frameInfo === void 0 ? void 0 : frameInfo.componentBasic) === null || _a === void 0 ? void 0 : _a.id;
            const highCabinetMesh = renderHThis.scene.getMeshByName(highCabinetId);
            const highCabinetMeshManage = new MeshManage(renderHThis.scene.getMeshByName(highCabinetId));
            const { position: { x: meshX, y: meshY } } = highCabinetMesh;
            const { x, y } = highCabinetMeshManage.getModelSize();
            const cabinetHeight = meshY + y;
            const positionLow = {
                x: (meshX + x / 2) / 2,
                y: cabinetHeight - HIGHTLOW_SINKCABINET_HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
                z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2, // (水槽柜z+台面伸出来的部分)/2
            };
            const sizeLow = {
                width: Math.abs(meshX + x / 2),
                height: TOPPANELCONFIG.HEIGHT,
                depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
            };
            const positionExtra = {
                x: meshX + x / 2 + TOPPANELCONFIG.HEIGHT / 2,
                y: cabinetHeight - (HIGHTLOW_SINKCABINET_HEIGHT - TOPPANELCONFIG.HEIGHT) / 2,
                z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2,
            };
            const sizeExtra = {
                width: TOPPANELCONFIG.HEIGHT,
                height: HIGHTLOW_SINKCABINET_HEIGHT - TOPPANELCONFIG.HEIGHT,
                depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
            };
            // 高台面信息
            const positionHigh = {
                // 水槽柜位置加上水槽x的一半然后/2 是左边台面的中心点   会多出来一个台面的厚度 全在内侧所以需要偏移台面的位置
                x: (meshX + x / 2 - lengthXLength.length) / 2 + TOPPANELCONFIG.HEIGHT / 2,
                y: cabinetHeight + TOPPANELCONFIG.HEIGHT / 2,
                z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2, // (水槽柜z+台面伸出来的部分)/2
            };
            const sizeHigh = {
                width: lengthXLength.length - Math.abs((meshX + x / 2)) + TOPPANELCONFIG.HEIGHT,
                height: TOPPANELCONFIG.HEIGHT,
                depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
            };
            return [{
                    position: positionLow, size: sizeLow,
                }, {
                    position: positionExtra, size: sizeExtra,
                }, {
                    position: positionHigh, size: sizeHigh,
                }];
        }
        if (stovePositionInfo === 1) {
            return [{
                    position: {
                        x: lengthXLength.centerPoint,
                        y: FRAME_HEIGHT.LOW + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
                        z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2,
                    },
                    size: {
                        width: lengthXLength.length,
                        height: TOPPANELCONFIG.HEIGHT,
                        depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
                    },
                }];
        }
        return [{
                position: {
                    x: lengthXLength.centerPoint,
                    y: FRAME_HEIGHT.HIGH + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
                    z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2,
                },
                size: {
                    width: lengthXLength.length,
                    height: TOPPANELCONFIG.HEIGHT,
                    depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
                },
            }];
    }
    // 不是高低柜返回正常的台面信息
    return [{
            position: {
                x: lengthXLength.centerPoint,
                y: renderHThis.templateJson.bottom.height * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
                z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2,
            },
            size: {
                width: lengthXLength.length,
                height: TOPPANELCONFIG.HEIGHT,
                depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
            },
        }];
}
// 获取l3边的台面信息
export function getLengthP2XTopPanelInfo(renderHThis, lengthXLength, sinkLocation, stovePositionInfo) {
    var _a;
    const l3CabinetPositionZ = FRAMEDEPTH.BOTTOM + AISLE_WIDTH + FRAMEDEPTH.BOTTOM / 2; // l3的底柜的中心位置   过道固定宽度为120
    if (getIsHighSinkCabinet(renderHThis.templateJson)) {
        const { l3Frame: { frameInfo, }, } = getDividingPosition(renderHThis.templateJson);
        if (frameInfo) {
            const { l3Frame } = getDividingPosition(renderHThis.templateJson);
            const { frameInfo } = l3Frame;
            const highCabinetId = (_a = frameInfo === null || frameInfo === void 0 ? void 0 : frameInfo.componentBasic) === null || _a === void 0 ? void 0 : _a.id;
            const highCabinetMesh = renderHThis.scene.getMeshByName(highCabinetId);
            const highCabinetMeshManage = new MeshManage(renderHThis.scene.getMeshByName(highCabinetId));
            const { position: { x: meshX, y: meshY } } = highCabinetMesh;
            const { x, y } = highCabinetMeshManage.getModelSize();
            const cabinetHeight = meshY + y;
            const positionLow = {
                x: (meshX + x / 2) / 2,
                y: cabinetHeight - HIGHTLOW_SINKCABINET_HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
                z: l3CabinetPositionZ - TOPPANELCONFIG.DEPTH / 2, // (水槽柜z+台面伸出来的部分)/2
            };
            const sizeLow = {
                width: Math.abs(meshX + x / 2),
                height: TOPPANELCONFIG.HEIGHT,
                depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
            };
            const positionExtra = {
                x: meshX + x / 2 + TOPPANELCONFIG.HEIGHT / 2,
                y: cabinetHeight - (HIGHTLOW_SINKCABINET_HEIGHT - TOPPANELCONFIG.HEIGHT) / 2,
                z: l3CabinetPositionZ - TOPPANELCONFIG.DEPTH / 2,
            };
            const sizeExtra = {
                width: TOPPANELCONFIG.HEIGHT,
                height: HIGHTLOW_SINKCABINET_HEIGHT - TOPPANELCONFIG.HEIGHT,
                depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
            };
            // 高台面信息
            const positionHigh = {
                // 水槽柜位置加上水槽x的一半然后/2 是左边台面的中心点   会多出来一个台面的厚度 全在内侧所以需要偏移台面的位置
                x: (meshX + x / 2 - lengthXLength.length) / 2 + TOPPANELCONFIG.HEIGHT / 2,
                y: cabinetHeight + TOPPANELCONFIG.HEIGHT / 2,
                z: l3CabinetPositionZ - TOPPANELCONFIG.DEPTH / 2, // (水槽柜z+台面伸出来的部分)/2
            };
            const sizeHigh = {
                width: lengthXLength.length - Math.abs((meshX + x / 2)) + TOPPANELCONFIG.HEIGHT,
                height: TOPPANELCONFIG.HEIGHT,
                depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
            };
            return [{
                    position: positionLow, size: sizeLow,
                }, {
                    position: positionExtra, size: sizeExtra,
                }, {
                    position: positionHigh, size: sizeHigh,
                }];
        }
        if (stovePositionInfo === 2) {
            return [{
                    position: {
                        x: lengthXLength.centerPoint,
                        y: FRAME_HEIGHT.LOW + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
                        z: l3CabinetPositionZ - TOPPANELCONFIG.DEPTH / 2,
                    },
                    size: {
                        width: lengthXLength.length,
                        height: TOPPANELCONFIG.HEIGHT,
                        depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
                    },
                }];
        }
        return [{
                position: {
                    x: lengthXLength.centerPoint,
                    y: FRAME_HEIGHT.HIGH + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
                    z: l3CabinetPositionZ - TOPPANELCONFIG.DEPTH / 2,
                },
                size: {
                    width: lengthXLength.length,
                    height: TOPPANELCONFIG.HEIGHT,
                    depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
                },
            }];
    }
    return [{
            position: {
                x: lengthXLength.centerPoint,
                y: renderHThis.templateJson.bottom.height * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
                z: l3CabinetPositionZ - TOPPANELCONFIG.DEPTH / 2,
            },
            size: {
                width: lengthXLength.length,
                height: TOPPANELCONFIG.HEIGHT,
                depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
            },
        }];
}
